(function(){
'use strict';
if(window.PGRewardSecurityV101Installed)return;
window.PGRewardSecurityV101Installed=true;

var cfg=window.PGMugRewardV101||{};
var rewardCfg=window.PGRewardV101||{};
var country=String(rewardCfg.country||cfg.country||'').toUpperCase();
var isUK=country==='GB'||country==='UK';
var isUS=country==='US';
var isRewardMarket=isUK||isUS;
var IDS={
  mug:Number(cfg.freeVariantId||51255823335676),
  digital:51223262560508,
  first:51223262593276,
  a5:Number(rewardCfg.a5VariantId||0)
};
var busy=false,timer=0;

function root(){
  var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/';
  return r.endsWith('/')?r:r+'/';
}
function prop(item,key){
  return item&&item.properties&&item.properties[key]!=null?String(item.properties[key]):'';
}
function rewardKind(item){
  var id=Number(item&&item.variant_id);
  if(id===IDS.mug)return'mug';
  if(id===IDS.digital)return'digital';
  if(id===IDS.first)return'first';
  if(IDS.a5>0&&id===IDS.a5)return'a5';
  return'';
}
function sourceMatches(cart,item){
  var key=prop(item,'_pg_source_key');
  var productId=prop(item,'_pg_source_product');
  var variantId=prop(item,'_pg_source_variant');
  if(!key||!productId||!variantId)return false;
  var group=prop(item,'_pg_artwork_group');
  return (cart.items||[]).some(function(line){
    if(rewardKind(line))return false;
    return String(line.key||'')===key&&
      String(line.product_id||'')===productId&&
      String(line.variant_id||'')===variantId&&(!isRewardMarket||!group||prop(line,'_pg_artwork_group')===group);
  });
}
function authorised(cart,item,kind){
  if(!(prop(item,'_pg_reward_v101')===kind&&prop(item,'_pg_same_artwork')==='true'&&sourceMatches(cart,item)))return false;
  if(!isRewardMarket)return true;
  if(kind==='mug'||Number(item.quantity||0)!==1||cart.currency!==(isUS?'USD':'GBP'))return false;
  var engine=window.PGRewardEngineV101,spend=engine&&typeof engine.qualifyingSpend==='function'?engine.qualifyingSpend(cart):0;
  var tier1=isUS?Number(rewardCfg.usDigitalThreshold||9800):Number(rewardCfg.ukDigitalThreshold||7500);
  var tier2=isUS?Number(rewardCfg.usA5Threshold||12400):Number(rewardCfg.ukA5Threshold||9500);
  if(!Number.isSafeInteger(spend)||spend<tier1)return false;
  if(kind==='a5'&&(spend<tier2||!prop(item,'_pg_artwork_group')||String((cart.attributes||{})._pg_a5_declined||'')==='true'))return false;
  return true;
}
async function getCart(){
  var response=await fetch(root()+'cart.js',{
    credentials:'same-origin',
    cache:'no-store',
    headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}
  });
  if(!response.ok)throw new Error('Cart read failed');
  return response.json();
}
async function audit(){
  if(busy)return null;
  busy=true;
  try{
    var cart=await getCart(),updates={},dirty=false,seen={};
    (cart.items||[]).forEach(function(item){
      var kind=rewardKind(item);
      if(kind&&(!authorised(cart,item,kind)||(isRewardMarket&&seen[kind]))){
        updates[item.key]=0;
        dirty=true;
      }else if(kind&&isRewardMarket){seen[kind]=true;}
    });
    if(!dirty)return cart;
    var response=await fetch(root()+'cart/update.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{
        Accept:'application/json',
        'Content-Type':'application/json',
        'X-Requested-With':'XMLHttpRequest'
      },
      body:JSON.stringify({updates:updates})
    });
    if(!response.ok)throw new Error('Reward cleanup failed');
    cart=await getCart();
    document.dispatchEvent(new CustomEvent('pg:reward-security-cleaned',{detail:{cart:cart}}));
    if(window.PGRewardEngineV101&&typeof window.PGRewardEngineV101.refresh==='function'){
      setTimeout(function(){window.PGRewardEngineV101.refresh().catch(function(){})},0);
    }
    return cart;
  }catch(error){
    console.warn('Paw & Glory V101 reward security:',error&&error.message||error);
    return null;
  }finally{
    busy=false;
  }
}
function schedule(ms){
  clearTimeout(timer);
  timer=setTimeout(function(){timer=0;audit();},ms==null?20:ms);
}
function boot(){
  schedule(0);
  setTimeout(audit,250);
  setTimeout(audit,900);
  ['cart:refresh','shopify:cart:lines-update','pg:cart-form-patched','pg:cart-synchronised'].forEach(function(name){
    document.addEventListener(name,function(){schedule(30);});
  });
  window.addEventListener('pageshow',function(){schedule(0);});
  if(window.InstantClick&&typeof window.InstantClick.on==='function'){
    window.InstantClick.on('change',function(){schedule(0);});
  }
}
window.PGRewardSecurityV101={audit:audit};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
else boot();
})();
